import styled from "styled-components"

import FavouriteIconButton from "../../Favourite/IconButton"

export default styled(FavouriteIconButton)`
  position: absolute;
  top: 0;
  right: 0;
  padding: 7px 10px 20px 20px;

  ${({theme}) => theme.mediaQueries.minWidthMedia.tablet`
    padding: ${theme.spacing.two};
  `}
`
